module.exports = __webpack_public_path__ + "img/shequ-3.b1a4e489.png";